import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  InputBase,
  DialogContent,
  DialogTitle,
  Dialog,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UsePagesVisitReport } from "./UsePagesVisitReport";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import CheckIcon from "@mui/icons-material/Check";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ProgressCom from "../../components/ProgressCom";
import { useSnackbar } from "notistack";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function DailyPagesVisitReport(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { toSolar } = require("jdate-convert");
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    GetDailyPageVisitReport,
    GetProductVisitCache,
    GetArticleVisitCache,
  } = UsePagesVisitReport();

  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Visit", "Desc");
  const [opendialog, setOpendialog] = useState({
    show: false,
    name: "",
    value: undefined,
  });
  const [dailyReport, setDailyReport] = useState();
  const [SPSState, setSPSState] = useState();
  const [reportType, setReportType] = useState(1);
  const [searchState, setSearchState] = useState("");
  const [search, setSearch] = useState("");
  const [valueStart, setValueStart] = useState();
  const { isSmall } = useBreakpoints();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [filters, setFilters] = useState({
    reportDate: new Date().toJSON().slice(0, 10),
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    if (props.expanded === "panel2" && filters.reportDate) {
      setProgress(true);
      GetDailyPageVisitReport(
        search,
        reportType,
        filters.reportDate,
        myPc,
        (callback) => {
          setDailyReport(callback);
        }
      );
    }
  }, [myPc, search, filters, reportType, props.expanded]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  useEffect(() => {
    if (valueStart) {
      let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      setFilters({ ...filters, reportDate: newValueStart });
    }
  }, [valueStart]);

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
  };

  const onSobmit = () => {
    if (SPSState && SPSState == 2662) {
      if (opendialog && opendialog.value == "products") {
        setProgress(true);
        GetProductVisitCache(() => {
          GetDailyPageVisitReport(
            search,
            reportType,
            filters.reportDate,
            myPc,
            (callback) => {
              setOpendialog({
                ...opendialog,
                show: false,
              });
              setSPSState();

              setDailyReport(callback);
            }
          );
        });
      } else if (opendialog && opendialog.value == "article") {
        setProgress(true);

        GetArticleVisitCache(() => {
          GetDailyPageVisitReport(
            search,
            reportType,
            filters.reportDate,
            myPc,
            (callback) => {
              setOpendialog({
                ...opendialog,
                show: false,
              });
              setSPSState();

              setDailyReport(callback);
            }
          );
        });
      } else if (opendialog && opendialog.value == "landing") {
        console.log("landing");
      }
    } else {
      enqueueSnackbar("رمز عبور صحیح نیست", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return;
    }
  };

  const columns = [
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
    },
    {
      field: "pageName",
      headerName: "محصول",
      width: 300,
      align: "center",

      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.pageName}
          </Typography>
        );
      },
    },

    {
      field: "dayVisit",
      headerName: "بازدید روز",
      width: 120,
      align: "center",

      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.dayVisit ? toMoney(cellValues.row.dayVisit) : 0}
          </Typography>
        );
      },
    },
    {
      field: "visit",
      headerName: "بازدید",
      width: 120,
      align: "center",

      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visit ? toMoney(cellValues.row.visit) : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalVisit",
      headerName: "بازدید مجموع",
      width: 120,
      align: "center",
      hide: reportType == 1 ? false : true,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.totalVisit ? toMoney(cellValues.row.totalVisit) : 0}
          </Typography>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Accordion
      expanded={props.expanded === "panel2"}
      onChange={handleChange("panel2")}
      style={{
        margin: isSmall ? 0 : "20px",
        marginBottom: isSmall && "20px",
        paddingBottom: "15px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            گزارش بازدید روزانه
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={opendialog.show}
          onClose={() => {
            setSPSState();
            setOpendialog({ ...opendialog, show: false });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <Typography color="secondary" variant="subtitle1">
              اگر از ثبت بازدید {opendialog.name} اطمینان دارید لطفا رمز عبور را
              وارد کنید :
            </Typography>
          </DialogTitle>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextField
              sx={{
                my: 2,
                width: isSmall ? "100%" : "50%",
                input: { textAlign: "center" },
              }}
              label="رمز عبور"
              value={SPSState ? SPSState : ""}
              onChange={(evt) => {
                setSPSState(evt.target.value);
              }}
              autoComplete="off"
              type={SPSState ? "password" : "text"}
              size="small"
              inputProps={{
                autocomplete: "new-password",
                form: {
                  autocomplete: "off",
                },
              }}
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSobmit();
                }
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button
                variant="contained"
                onClick={() => {
                  onSobmit();
                }}
              >
                ثبت
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setSPSState();

                  setOpendialog({ ...opendialog, show: false });
                }}
              >
                انصراف
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
        <Box
          sx={{
            display: "flex",
            alignItems: isSmall ? "flex-start" : "center",
            flexDirection: isSmall ? "column" : "row",
            justifyContent: "space-between",
            mb: 2,
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Button
              sx={{ width: "100px" }}
              color="secondary"
              startIcon={reportType == 1 && <CheckIcon />}
              variant={reportType == 1 ? "contained" : "outlined"}
              onClick={() => {
                setReportType(1);
              }}
            >
              محصول
            </Button>
            <Button
              sx={{
                width: "100px",
                mx: 2,
              }}
              color="secondary"
              startIcon={reportType == 2 && <CheckIcon />}
              variant={reportType == 2 ? "contained" : "outlined"}
              onClick={() => {
                setReportType(2);
              }}
            >
              مقاله
            </Button>
            <Button
              sx={{
                width: "100px",
              }}
              color="secondary"
              startIcon={reportType == 3 && <CheckIcon />}
              variant={reportType == 3 ? "contained" : "outlined"}
              onClick={() => {
                setReportType(3);
              }}
            >
              لندینگ
            </Button>
          </Box>
          <DatePicker
            weekDays={weekDays}
            calendar={persian}
            locale={persian_fa}
            format="YYYY-MM-DD"
            onChange={setValueStart}
            value={filters.reportDate ? toSolar(filters.reportDate) : ""}
            render={
              <TextField
                sx={{ pr: 2, input: { textAlign: "center" } }}
                variant="outlined"
                size="small"
                fullWidth
                label="تاریخ"
              />
            }
          />
        </Box>
        <Box sx={{ height: "35rem", mb: 2 }}>
          {dailyReport ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={
                dailyReport && dailyReport.pageCondition
                  ? dailyReport.pageCondition.pageCount
                  : 1
              }
              rows={dailyReport ? dailyReport.items : []}
              paginationMode="server"
              page={
                dailyReport && dailyReport.pageCondition
                  ? dailyReport.pageCondition.page - 1
                  : 1
              }
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                dailyReport && dailyReport.pageCondition
                  ? dailyReport.pageCondition.totalItemCount
                  : 1
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount:
                    dailyReport && dailyReport.pageCondition
                      ? dailyReport.pageCondition.totalItemCount
                      : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography color="secondary" variant="subtitle1">
            ثبت بازدید
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Button
              sx={{ width: "100px" }}
              variant="contained"
              onClick={() => {
                setOpendialog({
                  show: true,
                  name: "محصولات",
                  value: "products",
                });
              }}
            >
              محصولات
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "100px",
                mx: 2,
              }}
              color="secondary"
              onClick={() => {
                setOpendialog({
                  show: true,
                  name: "مقالات",
                  value: "article",
                });
              }}
            >
              مقالات
            </Button>
            <Button
              variant="contained"
              color="info"
              sx={{
                width: "100px",
              }}
              onClick={() => {
                setOpendialog({
                  show: true,
                  name: "لندینگ",
                  value: "landing",
                });
              }}
            >
              لندینگ
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
